import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const AddUnits = ({ show, onClose, onUnitCreated, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [selectedOption, setSelectedOption] = useState([]);
    const [unitCatOptions, setUnitCatOptions] = useState([]);
    const [unitName, setUnitName] = useState('');
    const [slugName, setSlugName] = useState(''); 
    const [description, setDescription] = useState(''); 
    const [loading, setLoading] = useState(false);
 
     useEffect(() => {
        axios.get(`${baseURL}/unitcategory/category/active`)
            .then(res => {
                const options = res.data.data.map(cat => ({
                    value: cat.unitcategory_id,
                    label: cat.unitcategory_name
                }));
                // Add "All" option at the top
                setUnitCatOptions([{ value: 'all', label: 'All' }, ...options]);
            })
            .catch(err => {
                console.error('Failed to fetch unit categories:', err);
            });
    }, []);

    const handleCategoryChange = (selected) => {
        // If "All" is selected, select all except "All"
        if (selected && selected.find(opt => opt.value === 'all')) {
            const allWithoutAll = unitCatOptions.filter(opt => opt.value !== 'all');
            setSelectedOption(allWithoutAll);
        } else {
            setSelectedOption(selected);
        }
    };

    // Handle form submission
    const handleSubmit = async () => {
        const unit_category_snos = selectedOption.map(option => option.value);

        if (!unitName || unit_category_snos.length === 0) {
            // Swal.fire("Validation Error", "Please fill all required fields.", "warning");
            return;
        } 

        const payload = {
            unit_name: unitName,
            unitslug_name: slugName || null,
            description,
            unit_category_snos,
        };

        try {
            setLoading(true);
            const res = await axios.post(`${baseURL}/manageunit`, payload);
            // Swal.fire("Success", res.data.message, "success");
            onClose();
            setUnitName('');
            setSlugName('');
            setDescription('');
            setSelectedOption([]);
            if (onUnitCreated) onUnitCreated(); // Trigger parent to refresh unit list
            // window.location.reload();
            refresh();
            toast.success("Unit Created successfully!");
        } catch (err) {
            const message = err.response?.data?.message || 'Something went wrong';
            const errors = err.response?.data?.errors;
            if (errors) {
                const errorList = Object.values(errors).flat().join('<br>');
                // Swal.fire("Validation Error", errorList, "error");
            } else {
                // Swal.fire("Error", message, "error");
                toast.error("Create failed:");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Units</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Units"
                                value={unitName}
                                onChange={(e) => setUnitName(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Short Name</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Short Name"
                                value={slugName}
                                onChange={(e) => setSlugName(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Unit Category<span className="required">*</span></label>
                            <Select
                                placeholder='Select Unit Category'
                                isMulti
                                value={selectedOption}
                                onChange={handleCategoryChange}
                                options={unitCatOptions}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={8}
                                className="form-control"
                                name="comment"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Button
                            className="btn btn-sm btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? <Spinner animation="border" size="sm" /> : 'Create Units'}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddUnits;
